module.exports = __webpack_public_path__ + "img/CM-SS-CA-Hyundai-Established.01890638.jpg";